import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import * as React from "react";

import packageJson from "../../package.json";

function Copyright() {
  return (
    <Typography
      variant="body2"
      sx={{
        color: "text.secondary",
      }}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://getslideapp.com">
        Slide
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

function Version() {
  return (
    <Typography
      variant="body2"
      sx={{
        color: "text.secondary",
      }}
    >
      {packageJson.version}-{import.meta.env.VITE_ENV}
    </Typography>
  );
}

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: "auto",
        backgroundColor: (theme) =>
          theme.palette.mode === "light"
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
      }}
    >
      <Container>
        <Grid
          container
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Grid>
            <Copyright />
          </Grid>
          <Grid>
            <Version />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
